import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardHeader,
  FileInput,
  FileInputExtendedProps,
  Form,
  FormField,
  RadioButton,
  Select,
  TextInput,
} from "grommet";
import { useNavigate } from "react-router-dom";
import "./profile.css";
import { MedicalEmergencyHelper } from "../../../../../../../util/medical-emergency/MedicalEmergencyHelper";
import { useUser } from "../../../../../context/User/UserContext";


function Profile() {
    const { user, setUser } = useUser();
    const [selectedOption, setSelectedOption] = useState('');
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [familyName, setFamilyName] = useState('');
    const [gender, setGender] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [userName, setUserName] = useState('');

    
    const navigate = useNavigate();

    useEffect(() => {
        if ( user?.email ) {
            console.log(user?.email);
            setEmail(user?.email);
        }
        if ( user?.name ) {
            setName(user?.name);
        }
        if ( user?.family_name ) {
            setFamilyName(user?.family_name);
        }
        if ( user?.gender ) {
            setGender(user?.gender);
            setSelectedOption(user?.gender);
        }
        if ( user?.username ) {
            setUserName(user?.username);
        }
    },[user]);

    const handleOptionChange = (event: any) => {
        setSelectedOption(event.target.value);
        setGender(event.target.value);
      };

      async function updateprofile() {
    const  getdata= await MedicalEmergencyHelper.updateProfile(name,email,familyName,gender,user?.username,phoneNumber);
    if(getdata.id)
    {
    console.log("hello");
    console.log(getdata);
    }
       
      };
      



  return (
    <Box className="create-user-container">
      <p className="message-text" style={{marginBottom: 10}}>Profile</p>
      <Card pad="medium" gap="medium">
        <Form
          validate="change"
          className="create-user-form"
        >

        <FormField name="email">
            <TextInput
                placeholder="Email"
                id="textinput-id"
                name="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
            />
        </FormField>

        <FormField name="name">
            <TextInput
                placeholder="Name"
                id="textinput"
                name="name"
                type="text"
                value={name}
                onChange={(event) => setName(event.target.value)}
            />
        </FormField>
        <FormField>
            <TextInput
                placeholder="Family Name"
                id="textinput"
                name="familyName"
                type="text"
                value={familyName}
                onChange={(event) => setFamilyName(event.target.value)}
            />
        </FormField>

        <FormField>
            <TextInput
                placeholder="Phone Number"
                id="textinput"
                name="phoneNumber"
                type="number"
                value={phoneNumber}
                onChange={(event) => setPhoneNumber(event.target.value)}
            />
        </FormField>

        <FormField>
            <TextInput
                placeholder="User Name"
                id="textinput"
                name="userName"
                type="text"
                readOnly={true}
                value={userName}
                style={{color: '#999'}}
            />
        </FormField>


        <h4 className="gdr-label">Gender</h4>
        <FormField className="radioButton" style={{display: 'flex',flexDirection: 'row',borderBottom: 'none'}}>
            <RadioButton
                name="radioInput"
                label="Male"
                value="male"
                checked={selectedOption === "male"}
                onChange={handleOptionChange}
            />
            <RadioButton
                name="radioInput"
                label="Female"
                value="female"
                checked={selectedOption === "female"}
                onChange={handleOptionChange}
            />
        </FormField>

          <Box direction="row" gap="medium" pad={"medium"} style={{paddingLeft: 0}} justify="start">
            <Button type="submit"  primary label="Update Profile" color={"brand-1"} onClick={updateprofile} />
          </Box>
        </Form>
      </Card>
    </Box>
  );
}

export default Profile;
